import React, { useState, useEffect, useCallback } from "react";
import "./Cartbody_module.css";
import PreistCartItemCard from "./PreistCartItemCard";
import TentCartItemCard from "./TentCartItemCard";
import CateringCartItemCard from "./Cateringcartitemscard";
import { useDispatch, useSelector } from "react-redux";
import { setEventDetails } from "../../store/eventsliceforcart";
import { useTentCart } from "../../hooks/useTentCart";
import { usePriestCart } from "../../hooks/usePriestCart";
import { useCateringCart } from "../../hooks/usecateringcart";
import { useNavigate } from "react-router-dom";
import MyButton1 from "../CustomComponents/MyButton1";
import ShowButtonToEventServices from "./ShowButtonToEventServices";
import { selectAllEventDetails } from "../../store/eventsliceforcart";
import { Dialog } from "primereact/dialog";
import { PlaceOrder, payment_checkout, payment_verification } from "../../Apiservices/Auth/payments/orderevent"
import { fetchEvent } from "../../Apiservices/Auth/servers/fetchEvents";
import { ShowDialogForPayment } from "../eventComponent/EventTabs/showdialogforpayment";

import { useInvoiceActions } from "../../component/ServiceProvider/userInvoiceActions";

const Cartbody = () => {
  const cartData = useSelector((state) => state.cartbodyslice.cart);
  // console.log("cartbodydata",cartData)
  const eventDataMap = useSelector(selectAllEventDetails);

  const { showEstimateInvoice } = useInvoiceActions();



  const {
    tentCartLoading,
    refreshTentCart,
    removeTentProvider,
    editbutton,
    refundtentproviderfromcart
  } = useTentCart();
  const {
    priestCartLoading,
    refreshPriestCart,
    removePriestCartItem,
    refundpreistfromcart
  } = usePriestCart();
  const {
    cateringCartLoading,
    refreshCateringCart,
    editCateringItems,
    removeCateringProvider,
    refundcateringfromcart,
  } = useCateringCart();


  const navigate = useNavigate();
  const [selectedItems, setSelectedItems] = useState({});
  const [refundItems, setRefundItems] = useState([]);
  const [showDialog, setShowDialog] = React.useState(false);


  const toggleAllForEvent = (isSelected, eventId, services) => {
    setSelectedItems((prev) => ({
      ...prev,
      [eventId]: {
        priestData: !!services.priestData?.length && isSelected,
        tentHouseData: !!services.tentHouseData?.length && isSelected,
        cateringData: !!services.cateringData?.length && isSelected,
      },
    }));
  };
  const toggleSelectAllEvents = (isSelected) => {
    const newSelections = {};

    Object.entries(cartData).forEach(([eventId, services]) => {
      newSelections[eventId] = {
        priestData: !!services.priestData?.length && isSelected,
        tentHouseData: !!services.tentHouseData?.length && isSelected,
        cateringData: !!services.cateringData?.length && isSelected,
      };
    });

    setSelectedItems(newSelections);
  };


  const isCartEmpty = Object.values(cartData || {}).every((event) => {
    const { tentHouseData = [], priestData = [], cateringData = [] } = event;
    return (
      (!tentHouseData || tentHouseData.length === 0) &&
      (!priestData || priestData.length === 0) &&
      (!cateringData || cateringData.length === 0)
    );
  });
  const [paymentboxdialog, setpaymentboxdialog] = useState(false)
  const [paymentamount, setpaymentamount] = useState(0);

  useEffect(() => {
    if (isCartEmpty) {
      const timer = setTimeout(() => {
        navigate("/dashboard", { state: { message: "Please add something to your cart" } });
      }, 3000);

      // cleanup timer if user leaves early
      return () => clearTimeout(timer);
    }
  }, [isCartEmpty, navigate]);
  const [selectedcartitem, setSelectedcartitem] = useState([]);


  const handleselectedcart = (eventId, serviceType, checked, item, total) => {
    setSelectedcartitem((prev) => {
      const existingEvent = prev.find((p) => p.eventid === eventId);

      if (checked) {
        // Add provider
        if (existingEvent) {
          return prev.map((p) =>
            p.eventid === eventId
              ? {
                ...p,
                services: {
                  ...p.services,
                  [serviceType]: [
                    ...(p.services[serviceType] || []).filter(
                      (d) => d.id !== item.id // avoid duplicates by provider id
                    ),
                    item,
                  ],
                },
              }
              : p
          );
        } else {
          return [
            ...prev,
            { eventid: eventId, services: { [serviceType]: [item] } },
          ];
        }
      } else {
        //  Remove provider
        if (existingEvent) {
          const updated = (existingEvent.services[serviceType] || []).filter(
            (d) => d.id !== item.id // remove provider by id
          );

          if (updated.length === 0) {
            // remove the serviceType key if empty
            const { [serviceType]: _, ...restServices } = existingEvent.services;
            if (Object.keys(restServices).length === 0) {
              return prev.filter((p) => p.eventid !== eventId);
            }
            return prev.map((p) =>
              p.eventid === eventId ? { ...p, services: restServices } : p
            );
          }

          return prev.map((p) =>
            p.eventid === eventId
              ? {
                ...p,
                services: { ...p.services, [serviceType]: updated },
              }
              : p
          );
        }
        return prev;
      }
    });
  };
  const finalpriceforallevents = selectedcartitem.reduce((eventAcc, event) => {
    const serviceTotal = Object.values(event.services).reduce((serviceAcc, arr) => {
      return serviceAcc + arr.reduce((itemAcc, item) => itemAcc + (item.total || 0), 0);
    }, 0);
    return eventAcc + serviceTotal;
  }, 0);

  const eventTotalsfinalprice = selectedcartitem.map((event) => {
    const total = Object.values(event.services).reduce((serviceAcc, arr) => {
      return serviceAcc + arr.reduce((itemAcc, item) => itemAcc + (item.total || 0), 0);
    }, 0);
    return { eventid: event.eventid, total };
  });


  const handelClose = () => {
    setpaymentboxdialog(false);
    setpaymentamount(0);
    setSelectedOption("")
  }
  const Onclick = async (eventId, price, eventData) => {
    // 1. Build amount object dynamically
    // console.log("amount", eventData);

    const mapping = {
      priest: { idKey: "priestId", sourceId: "id" },
      tenthouse: { idKey: "tentRentalId", sourceId: "id", alias: "tentRentals" },
      catering: { idKey: "cateringId", sourceId: "id" },
    };

    const amount = Object.fromEntries(
      Object.entries(mapping)
        .filter(([key]) => Array.isArray(eventData.services[key]) && eventData.services[key].length > 0)
        .map(([key, { idKey, sourceId, alias }]) => {
          const items = eventData.services[key].map(item => {
            // Transform cartid structure for tenthouse
            let cartid = item.cartid ?? [];

            if (key === 'tenthouse' && Array.isArray(cartid)) {
              // Extract cart_id from the new structure
              cartid = cartid.map(cartItem => ({
                mapping_id: cartItem.mapping_id,
                quantity: cartItem.quantity,
                cart_id: cartItem.cart_id, // Now using cart_id instead of cartid
              }));
            }

            if (key === 'catering' && Array.isArray(cartid)) {
              // Catering already has the right structure
              cartid = cartid.map(cartItem => ({
                mapping_id: cartItem.mapping_id,
                quantity: cartItem.quantity,
                service_id: cartItem.service_id,
              }));
            }

            return {
              [idKey]: item[sourceId],
              amount: item.total,
              cartid: cartid,
            };
          });
          return [alias || key, items];
        })
    );

    // console.log("Final amount object:", JSON.stringify(amount, null, 2));

    // 2. Call backend to create order
    try {
      const orderRes = await payment_checkout(eventId, amount);
      // console.log("payment_checkout", orderRes);

      // { orderId, amount, currency }
      const orderId = orderRes.order.id;

      // 3. Razorpay checkout options
      const options = {
        key: "rzp_test_RFbf7EMbdAj0Jz",
        amount: price * 100, // still pass amount for UI
        currency: "INR",
        order_id: orderId,
        name: "My Event Services",
        description: `Payment for Event ${eventId}`,
        handler: async function (response) {
          // console.log("Payment Success!");
          // console.log("Payment ID:", response);
          // console.log("Order ID:", response.razorpay_order_id);
          // console.log("Signature:", response.razorpay_signature);

          const verificationData = {
            razorpay_order_id: orderId,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
          };

          try {
            // Verify on backend
            await payment_verification(eventId, verificationData);
            alert("Payment successful & verified");
            window.location.reload();
          } catch (err) {
            console.error("Verification failed:", err);
            alert("Payment success but verification failed");
          }
        },
        prefill: {
          name: "Your Customer Name",
          email: "customer@email.com",
          contact: "9999999999",
        },
        theme: {
          color: "#26B8E3",
        },
      };

      // 4. Open Razorpay checkout
      const rzp1 = new window.Razorpay(options);

      // Failure case 
      rzp1.on("payment.failed", function (response) {
        console.error("Payment Failed:", response.error);
        alert(`Payment failed: ${response.error.description}`);
      });

      rzp1.open();
    } catch (error) {
      console.error("Error in payment checkout:", error);
      alert("Payment initialization failed");
    }
  };




  const [selectedOption, setSelectedOption] = useState("");
  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };
  const sendpaymentrequest = async () => {
    //need to call api for payment razopay
    const orderid = await PlaceOrder()
  }
  const dialogfooter = () => {
    return <MyButton1 title="confirm to pay" marginLeft="auto" fontSize="12px" padding="8px" method={() => { sendpaymentrequest() }} disabled={selectedOption === ""} />
  }
  const calculateEventTotal = ({ priestData = [], tentHouseData = [], cateringData = [] }) => {
    let total = 0;
    const currentDate = new Date();
    // Priest prices
    priestData.forEach(item => {
      const validUpto = item.validUpto ? new Date(item.validUpto) : null;
      const price = item.discountPrice !== undefined &&
        item.discountPrice !== null &&
        validUpto &&
        validUpto > currentDate
        ? item.discountPrice
        : item.price;
      total += price;
    });

    // Tent house prices
    tentHouseData.forEach(provider => {
      // console.log("pricevalues",provider.services);
      provider.services?.forEach(service => {
        const hasValidDiscount =
          service.discountPrice > 0 &&
          service.validUpto && new Date(service.validUpto) > currentDate;
        const price = hasValidDiscount
          ? (service.discountPrice ?? 0)
          : (service.price ?? 0);
        const quantity = service.quantity ?? 1;
        total += price * quantity;

      });
    });

    // Catering prices — FIXED HERE
    cateringData.forEach(provider => {

      provider.services?.forEach(service => {
        const hasValidDiscount =
          service.discountPrice > 0 &&
          service.validUpto && new Date(service.validUpto) > currentDate;

        const price = hasValidDiscount
          ? (service.discountPrice ?? 0)
          : (service.price ?? 0);
        const quantity = service.quantity ?? 1;
        total += price * quantity;
      });
    });

    return total; // Convert paise to rupees
  };


  if (tentCartLoading || priestCartLoading || cateringCartLoading) {
    return <div className="cart-loading">Loading your cart...</div>;
  }

  if (isCartEmpty) {
    return <div className="cart-maincontainer">Your cart is empty.</div>;
  }

  const backtoEvents = () => {
    navigate("/dashboard");
  };

  let overallTotal = 0;

  return (
    <div className="cart-maincontainer">
      <div className="cart-mainbody">
        <div className="cart-container">

          <div className="cart-body">
            <div className="cart_name">
              <div className="cart_name_title">
                Your Cart
              </div>
              <div className="dashboard-button">
                <button className="back_to_dashboard_in_provider" onClick={backtoEvents} >
                  <i className="pi pi-arrow-left"></i>
                  Back to Dashboard
                </button>
              </div>

            </div>
            <div>
              {/* Grand Total for all events */}
              <div className="grand-total">
                <h2>Grand Total for All Events: ₹{finalpriceforallevents}</h2>
                {/* <MyButton1 title="Pay Total now" marginLeft="auto"  fontSize="12px" padding="8px"/> */}
              </div>
              <div className="cart-footer">
                <span> {selectedcartitem.length} Vendors Added</span>
                {/* <MyButton1 title={`Pay ₹${finalpriceforallevents}`}  marginLeft="auto" fontSize="12px" padding="8px" method={()=> {Onclick(finalpriceforallevents)} }/> */}
              </div>
            </div>


            <div className="select_item_in_cart" style={{ marginLeft: "0px" }}>
              {/* <label>
    <input
      type="checkbox"
      checked={
        Object.keys(cartData).length > 0 &&
        Object.entries(cartData).every(([eventId, services]) =>
          selectedItems[eventId]?.priestData ||
          selectedItems[eventId]?.tentHouseData ||
          selectedItems[eventId]?.cateringData
        )
      }
      onChange={(e) => toggleSelectAllEvents(e.target.checked)}
    />
    Make payment for all events and services in the cart

  </label> */}
            </div>

            {Object.entries(cartData).map(([eventId, eventDetails]) => {
              // console.log("cartbodyevent",eventDataMap)
              const {
                eventname,
                priestData,
                tentHouseData,
                cateringData,
                event_start_date,
              } = eventDetails;

              const eventCart = {
                event: eventDataMap?.[eventId],
                cateringProviders: cateringData,
                tentProviders: tentHouseData,
                priestProviders: priestData
              }
              // const eventdate = 
              // const eventTotal = calculateEventTotal(eventDetails);
              // overallTotal += eventTotal;

              const activePriestData = priestData?.filter(item => !item.is_checked_out) || [];
              const activeTentData = tentHouseData?.filter(item => !item.is_checked_out) || [];
              const activeCateringData = cateringData?.filter(item => !item.is_checked_out) || [];

              // If all are empty, skip this event
              if (activePriestData.length === 0 && activeTentData.length === 0 && activeCateringData.length === 0) {
                return null;
              }

              const eventdate = eventDataMap?.[eventId]?.startDate
              const venulocation = eventDataMap?.[eventId]?.venue
              const date = new Date(eventdate);
              const formattedDate = date.toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "long",
                year: "numeric",
              });
              // console.log("eventDataMap",eventDataMap,eventId,eventdate)
              if (!eventdate || isNaN(date.getTime())) {
                return null;
              }
              const fullEventDetails = eventDataMap?.[eventId];

              const isEmpty =
                (!priestData || priestData.length === 0) &&
                (!tentHouseData || tentHouseData.length === 0) &&
                (!cateringData || cateringData.length === 0);

              if (isEmpty) return null;
              const eventTotal = selectedcartitem
                .find((p) => p.eventid === eventId)?.services || {};

              const eventPrice = Object.values(eventTotal).reduce((serviceAcc, arr) => {
                return serviceAcc + arr.reduce((itemAcc, item) => itemAcc + (item.total || 0), 0);
              }, 0);
              const selectedEventData = selectedcartitem.find((p) => p.eventid === eventId);
              const isDisabled = eventPrice <= 0 || !selectedEventData;


              return (
                <>

                  {/* <MyButton1 title={`Pay ₹${eventPrice}`} marginLeft="auto" fontSize="12px" padding="8px" disabled={isDisabled}
                    method={() => { Onclick(eventId, eventPrice, selectedEventData) }} /> */}
                  <div key={eventId} className="event-section">
                    <div className="event-header-cart">
                      <h2>{eventname || `Event`} on {formattedDate}  </h2>
                      <span style={{ fontWeight: "500" }}>Venue {venulocation}</span>
                      <div className="select_item_in_cart" >
                        <Dialog
                          header="Select Payment"
                          visible={paymentboxdialog}
                          onHide={handelClose}
                          style={{ width: "30vw" }}
                          modal
                          footer={dialogfooter}
                        >
                          <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>


                          </div>
                        </Dialog>
                      </div>

                    </div>

                    <div className="card-details-in_cart">
                      {priestData?.filter(item => !item.is_checked_out)?.length > 0 &&
                        (
                          <PreistCartItemCard
                            eventId={eventId}
                            eventname={eventname}
                            data={priestData}
                            serviceType="priestData"
                            refreshCart={refreshPriestCart}
                            removeItem={removePriestCartItem}
                            eventtitle={eventname ? eventname : ""}
                            refundpreistfromcart={refundpreistfromcart}
                            onPriestSelect={handleselectedcart}
                            selectedcartitem={selectedcartitem}
                            openRefundDialog={(items) => {
                              setRefundItems(items);
                              setShowDialog(true);
                            }}
                          />
                        )}

                      {tentHouseData?.filter(item => !item.is_checked_out)?.length > 0 && (
                        <TentCartItemCard
                          eventId={eventId}
                          eventname={eventname}
                          data={tentHouseData}
                          serviceType="tentHouseData"
                          refreshCart={refreshTentCart}
                          removeItem={removeTentProvider}
                          openEditDialog={(eventId, providerId, updatedItems) =>
                            editbutton(eventId, providerId, updatedItems)
                          }
                          eventtitle={eventname ? eventname : ""}
                          ontentSelect={handleselectedcart}
                          selectedcartitem={selectedcartitem}
                          refundtentproviderfromcart={refundtentproviderfromcart}
                          openRefundDialog={(items) => {
                            setRefundItems(items);
                            setShowDialog(true);
                          }}
                        />
                      )}

                      {cateringData?.filter(item => !item.is_checked_out)?.length > 0 &&
                        cateringData.map((provider, index) => (
                          <CateringCartItemCard
                            key={provider.provider_id || index}
                            eventId={eventId}
                            eventname={eventname}
                            data={[provider]}
                            serviceType="cateringData"
                            refreshCart={refreshCateringCart}
                            removeItem={removeCateringProvider}
                            openEditDialog={editCateringItems}
                            eventtitle={eventname ? eventname : ""}
                            oncateringSelect={handleselectedcart}
                            selectedcartitem={selectedcartitem}
                            refundcateringfromcart={refundcateringfromcart}
                            openRefundDialog={(items) => {
                              setRefundItems(items);
                              setShowDialog(true);
                            }}
                          />
                        ))}

                    </div>

                    {/* <button onClick={() => }>
                      View Estimate
                    </button> */}
                    {/* <MyButton1 title={`Place Order`} marginLeft="auto" marginBottom="10px" fontSize="14px" padding="10px" marginY="2px" disabled={false}
                      method={() => {
                        navigate("/checkout", {
                          state: {
                            eventId: eventId,

                            // event details
                            eventData: eventCart.event,

                            // providers (VERY IMPORTANT)
                            providers: {
                              priest: eventCart.priestData,
                              tent: eventCart.tentHouseData,
                              catering: eventCart.cateringData,
                            },
                          },
                        });
                      }} /> */}
                    <MyButton1 title={`View Estimate Invoice`} marginLeft="auto" marginBottom="10px" fontSize="14px" padding="10px" marginY="2px" disabled={false}
                      method={() => showEstimateInvoice(eventCart)} />


                    <div style={{ width: "100%", justifyContent: "space-between", display: "flex" }}>
                      <ShowButtonToEventServices
                        eventId={eventId}
                        cartData={cartData}
                        eventDetails={fullEventDetails}
                      />

                      <div >
                        {/* <MyButton1 title={`Place Order`} marginLeft="auto" fontSize="12px" padding="8px" disabled={isDisabled}
                          method={() => { Onclick(eventId, eventPrice, selectedEventData) }} /> */}
                        <MyButton1 title={`Place Order`} marginLeft="auto" marginBottom="10px" fontSize="14px" padding="10px" marginY="2px" disabled={false}
                          method={() => {
                            navigate("/checkout", {
                              state: {
                                eventId: eventId,

                                // event details
                                eventData: eventCart.event,

                                // providers (VERY IMPORTANT)
                                providers: {
                                  priest: eventCart.priestData,
                                  tent: eventCart.tentHouseData,
                                  catering: eventCart.cateringData,
                                },
                              },
                            });
                          }} />
                      </div>
                    </div>
                  </div>


                </>
              );
            })}


          </div>

        </div>


        <ShowDialogForPayment
          refundItems={refundItems}
          showDialog={showDialog}
          setShowDialog={setShowDialog}
        />


      </div>
    </div>
  );
};

export default Cartbody;
